import { render } from "./BlockAdBlock.vue?vue&type=template&id=12cd0ac6&scoped=true"
import script from "./BlockAdBlock.vue?vue&type=script&lang=js"
export * from "./BlockAdBlock.vue?vue&type=script&lang=js"

import "./BlockAdBlock.vue?vue&type=style&index=0&id=12cd0ac6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cd0ac6"]])

export default __exports__